import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortFileName', pure: true })
export class ShortFileNamePipe implements PipeTransform {
  transform(fullName: string): string {
    if (!fullName) { return ''; }
    const dotIdx = fullName.lastIndexOf('.');
    const ext     = dotIdx > -1 ? fullName.slice(dotIdx) : '';
    const usIdx   = fullName.lastIndexOf('_', dotIdx);
    return usIdx > -1
      ? fullName.slice(0, usIdx) + ext
      : fullName;
  }
}
